import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Zap } from "lucide-react";
import { CONSTANTS } from "../data";

interface TrendingDrinkBannerProps {
  trendingDrink: {
    id: string | null;
    endTime: number;
  };
}

const TrendingDrinkBanner: React.FC<TrendingDrinkBannerProps> = ({ trendingDrink }) => {
  const [timeLeft, setTimeLeft] = useState("");

  useEffect(() => {
    if (!trendingDrink.id || trendingDrink.endTime < Date.now()) {
      setTimeLeft("");
      return;
    }

    const updateTimer = () => {
      const remaining = trendingDrink.endTime - Date.now();
      if (remaining <= 0) {
        setTimeLeft("");
      } else {
        const minutes = Math.floor(remaining / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);
        setTimeLeft(`${minutes}:${seconds.toString().padStart(2, '0')}`);
      }
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval);
  }, [trendingDrink]);

  if (!trendingDrink.id || !timeLeft) {
    return null;
  }

  const drinkName = 
    CONSTANTS.ITEMS[trendingDrink.id]?.name ||
    Object.values(CONSTANTS.RECIPES).find(r => r.result.id === trendingDrink.id)?.result.name ||
    trendingDrink.id;

  return (
    <motion.div
      initial={{ height: 0, opacity: 0 }}
      animate={{ height: "auto", opacity: 1 }}
      className="bg-accent/80 text-white text-center py-2 font-semibold text-sm overflow-hidden flex items-center justify-center gap-2"
    >
      <Zap size={16} className="animate-pulse" />
      <span>
        Trending Drink: {drinkName} (+{CONSTANTS.TREND_SYSTEM.TIP_BONUS * 100}% Tip) ({timeLeft})
      </span>
    </motion.div>
  );
};

export default TrendingDrinkBanner;
